/**
 * Policy Total Calculator
 * 
 * Premio Totale Polizza = premium (base) + additional_services costs
 * Totale Incassato = Premio Totale + consultation_fee (commissioni)
 */

/**
 * Calculate the sum of additional services costs
 */
export function getServicesTotal(policy) {
  const services = policy?.additional_services || [];
  return services.reduce((sum, svc) => sum + (parseFloat(svc.cost) || 0), 0);
}

/**
 * Calculate total policy premium (base premium + additional services)
 */
export function getPolicyPremiumTotal(policy) {
  const base = parseFloat(policy?.premium) || 0;
  return base + getServicesTotal(policy);
}

/**
 * Calculate the full amount collected (premium + services + commission)
 */
export function getPolicyGrandTotal(policy) {
  return getPolicyPremiumTotal(policy) + (parseFloat(policy?.consultation_fee) || 0);
}
